import { IconBase, IconComponent } from './BaseIcon';

export const Inactive: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M28.1 9.1C24.2 2.4 15.7.1 9 3.9c-3.2 1.9-5.6 4.9-6.5 8.5C1.4 16 1.9 19.8 3.8 23c2.6 4.5 7.3 7 12.2 7 2.4 0 4.8-.6 6.9-1.9 6.7-3.7 9-12.3 5.2-19zM10 5.7c1.9-1.1 3.9-1.6 6-1.6 2.8 0 5.6 1 7.8 2.9l-17 16.8c-.5-.5-.9-1.1-1.3-1.8C2.2 16.3 4.2 9 10 5.7zm11.9 20.8c-4.5 2.6-10 1.9-13.7-1.3L25.1 8.3c.5.5.9 1.1 1.3 1.8 3.2 5.7 1.2 13.1-4.5 16.4z" />
  </IconBase>
);
